// extracted by mini-css-extract-plugin
export default {"date":"style_date__mxQH1","date_fromTo":"style_date_fromTo__ueN8J"};